import React, { useEffect, useState } from "react";
import clsx from "clsx";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ProfileImage from "../assets/Images/ProfileImage.jpg";
import CompanyLogoWithBGround from "../assets/Images/logo group.png";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  Drawer,
  Grid,
  IconButton,
  InputLabel,
  Link,
  List,
  Toolbar,
  Typography,
  TextField,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import MinListItems from "../components/MinListItems";
import { getUserDetail } from "../actions/UserAction";
import { userDetailsValidation } from "../utils/validation";
import { updateExistUser } from "../actions/PrivilegeAction";

// Copyright Component
function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

// Styling Constants
const drawerWidth = 300;
const rightDrawerWidth = 500;
const classes = {
  root: "root",
  toolbar: "toolbar",
  toolbarIcon: "toolbarIcon",
  companyIcon: "companyIcon",
  companyIconClose: "companyIconClose",
  appBar: "appBar",
  appBarShift: "appBarShift",
  style: "style",
  menuButton: "menuButton",
  menuButtonHidden: "menuButtonHidden",
  title: "title",
  drawerPaper: "drawerPaper",
  drawerPaperClose: "drawerPaperClose",
  appBarSpacer: "appBarSpacer",
  content: "content",
  container: "container",
  paper: "paper",
  large: "large",
};

// Styled Root Component
const Root = styled("div")(({ theme }) => ({
  [`&.${classes.root}`]: { display: "flex" },
  [`& .${classes.toolbar}`]: { paddingRight: 24 },
  [`& .${classes.toolbarIcon}`]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  [`& .${classes.companyIcon}`]: {
    margin: "10px",
    marginLeft: "20px",
    width: theme.spacing(12),
    height: theme.spacing(12),
  },
  [`& .${classes.companyIconClose}`]: { display: "none" },
  [`& .${classes.appBar}`]: {
    zIndex: theme.zIndex.drawer + 0,
    width: `calc(100% - ${70}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    boxShadow: "none",
  },
  [`& .${classes.appBarShift}`]: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxShadow: "none",
  },
  [`& .${classes.style}`]: { backgroundColor: "white" },
  [`& .${classes.menuButton}`]: { marginRight: 36 },
  [`& .${classes.menuButtonHidden}`]: { display: "none" },
  [`& .${classes.title}`]: { flexGrow: 1 },
  [`& .${classes.drawerPaper}`]: {
    borderRight: "none",
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  [`& .${classes.drawerPaperClose}`]: {
    borderRight: "none",
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: { width: theme.spacing(9) },
  },
  [`& .${classes.appBarSpacer}`]: { ...theme.mixins.toolbar },
  [`& .${classes.content}`]: {
    flexGrow: 1,
    position: "relative",
    height: "100vh",
    overflow: "auto",
  },
  [`& .${classes.container}`]: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  [`& .${classes.paper}`]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  [`& .${classes.large}`]: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    marginLeft: "25px",
  },
}));

// Drawer Header Styled Component
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-start",
}));

export default function Dashboard(props) {
  const [leftOpen, setLeftOpen] = useState(true);
  const [rightOpen, setRightOpen] = useState(false);
  const [loginUser, setLoginUser] = useState({
    id: "",
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    ProfileImage: "",
    role: [],
  });
  const [error, setError] = useState({
    firstName: false,
    lastName: false,
    userName: false,
    email: false,
    emailMissMatch: false,
    mobileNotValid: false,
    mobile: false,
  });
  const [enableUpdateBtn, setEnableUpdateBtn] = useState(false);
  const theme = useTheme();

  // Fetch user details on mount
  useEffect(() => {
    fetchLoginUser();
  }, []);

  useEffect(() => {
    setError({
      firstName: false,
      lastName: false,
      userName: false,
      email: false,
      mobileNotValid: false,
      mobile: false,
    });
  }, [loginUser]);

  const fetchLoginUser = async () => {
    const userDetail = getUserDetail((res) => {
      if (res) {
        setLoginUser({
          id: res.id ?? "",
          userName: res.userName ?? "",
          firstName: res.firstName ?? "",
          lastName: res.lastName ?? "",
          email: res.email ?? "",
          mobile: res.mobile ?? "",
          ProfileImage: res.profileImage ?? "",
        });
      }
    });
    await userDetail();
  };

  const handleDrawerOpen = () => setLeftOpen(true);
  const handleDrawerClose = () => setLeftOpen(false);

  const handleUpload = async () => {
    const accessCreate = userDetailsValidation(loginUser, setError);
    if (accessCreate) {
      setEnableUpdateBtn(false);

      const update = updateExistUser(loginUser, () => setRightOpen(false));
      await update();
    }
  };
  const handleClose = () => {
    setEnableUpdateBtn(false);
    setRightOpen(false);
    setError({
      firstName: false,
      lastName: false,
      userName: false,
      email: false,
      mobileNotValid: false,
      mobile: false,
    });
  };
  return (
    <Root className={classes.root}>
      <CssBaseline />
      <AppBar
        color="inherit"
        position="absolute"
        className={clsx(classes.appBar, leftOpen && classes.appBarShift)}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(
              classes.menuButton,
              leftOpen && classes.menuButtonHidden
            )}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            Data Entry Operator
          </Typography>
          <IconButton color="inherit" onClick={() => setRightOpen(true)}>
            <Avatar
              alt="User Profile"
              src={
                loginUser.ProfileImage !== ""
                  ? loginUser.ProfileImage
                  : ProfileImage
              }
              className={classes.large}
            />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Left Drawer */}
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(
            classes.drawerPaper,
            !leftOpen && classes.drawerPaperClose
          ),
        }}
        open={leftOpen}
      >
        <Grid container spacing={0}>
          <Grid item xs={6}>
            <Avatar
              alt="Company Logo"
              src={CompanyLogoWithBGround}
              className={clsx(
                classes.companyIcon,
                !leftOpen && classes.companyIconClose
              )}
            />
          </Grid>
          <Grid className={classes.toolbarIcon} item xs={6}>
            <IconButton
              onClick={handleDrawerClose}
              style={{ color: "#05234A" }}
              className={clsx(
                classes.menuButton,
                !leftOpen && classes.menuButtonHidden
              )}
            >
              <ChevronLeftIcon />
            </IconButton>
          </Grid>
        </Grid>
        <List style={{ marginTop: "20px" }}>
          <MinListItems open={leftOpen} />
        </List>
      </Drawer>

      {/* Right Drawer */}
      <Drawer
        sx={{
          width: 0,
          flexShrink: 0,
          transition: "width 0.3s ease-in-out",
          "& .MuiDrawer-paper": {
            width: rightDrawerWidth,
            boxShadow: "2px 0 10px rgba(0, 0, 0, 0.1)",
            padding: "20px",
            backgroundColor: "#f9f9f9",
          },
        }}
        variant="persistent"
        anchor="right"
        open={rightOpen}
      >
        <DrawerHeader sx={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton onClick={handleClose}>
            {theme.direction === "rtl" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            my: 2,
          }}
        >
          <Avatar
            alt="User Profile"
            src={
              loginUser.ProfileImage !== ""
                ? loginUser.ProfileImage
                : ProfileImage
            }
            sx={{ width: 100, height: 100, mb: 1 }}
          />
        </Box>
        <Divider />

        {/* User Info Form */}
        <Box sx={{ mt: 2, px: 3 }}>
          {[
            {
              label: "First Name",
              value: loginUser.firstName,
              id: "firstName",
            },
            { label: "Last Name", value: loginUser.lastName, id: "lastName" },
            { label: "Email", value: loginUser.email, id: "email" },
            { label: "Username", value: loginUser.userName, id: "userName" },
            { label: "Mobile", value: loginUser.mobile, id: "mobile" },
          ].map((field, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              <InputLabel sx={{ fontSize: 14, fontWeight: 500, color: "#555" }}>
                {field.label}
              </InputLabel>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                value={field.value}
                disabled={!enableUpdateBtn}
                onChange={(e) =>
                  setLoginUser({ ...loginUser, [field.id]: e.target.value })
                }
                sx={{
                  mt: 0.5,
                  "& .MuiInputBase-root": {
                    backgroundColor: "#fff",
                    borderRadius: 1,
                  },
                }}
              />
              {error?.[field.id] && (
                <Typography component="p" sx={{ color: "red", fontSize: 12 }}>
                  Please enter {field.label.toLowerCase()}
                </Typography>
              )}
              {field.id == "mobile" && error?.["mobileNotValid"] && (
                <Typography component="p" sx={{ color: "red", fontSize: 12 }}>
                  Please enter valid mobile number
                </Typography>
              )}
            </Box>
          ))}
        </Box>

        {/* Buttons Section */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            px: 3,
            mt: 3,
          }}
        >
          {!enableUpdateBtn ? (
            <Button
              variant="outlined"
              color="primary"
              sx={{ flex: 1, mx: 1 }}
              onClick={() => setEnableUpdateBtn(true)}
            >
              Edit
            </Button>
          ) : (
            <>
              <Button
                variant="outlined"
                color="error"
                sx={{ flex: 1, mx: 1 }}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="success"
                sx={{ flex: 1, mx: 1 }}
                onClick={handleUpload}
              >
                Update
              </Button>
            </>
          )}
        </Box>
      </Drawer>

      {/* Main Content */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          {props.children}
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
    </Root>
  );
}
